<template>
  <div class="pc-map-city">
    <div class="pc-cityList-bread">
      <h2>地图列表</h2>
      <BreadCrumb :data="breadcrumb" />
    </div>

    <div class="pc-map-cityList-cards">
      <ColorCard
        v-for="(cardinfo, index) in cardsInfo"
        :key="index"
        :pdata="cardinfo.message"
        :pcolor="cardinfo.color"
      />
    </div>

    <div class="pc-cityList-tab">
      <Tag :typeTagArgs="typeTagArgs" />
    </div>

    <div class="pc-cityList-table">
      <SearchTable />
    </div>
  </div>
</template>

<script>
import { getCityNums } from "./cityList/colorCard.gql";
import SearchTable from "./cityList/SearchTable.vue";
import ColorCard from "./cityList/ColorCard.vue";
import Tag from "../../template/Tag";
import BreadCrumb from "@/components/template/BreadCrumb";
export default {
  data() {
    return {
      cardsInfo: [
        {
          message: [0, "亚洲"],
          color: {
            blcolor: "#FAFF3C",
            brcolor: "#F7B500",
            color: "#F7B500",
          },
        },
        {
          message: [0, "欧洲"],
          color: {
            blcolor: "#0087FF",
            brcolor: "#42289B",
            color: "#3126C3",
          },
        },
        {
          message: [0, "美洲"],
          color: {
            blcolor: "#FFCB5C",
            brcolor: "#CA2F2F",
            color: "#CA2F2F",
          },
        },
        {
          message: [0, "非洲"],
          color: {
            blcolor: "#D6D7E9",
            brcolor: "#081745",
            color: "#5470C6",
          },
        },
        {
          message: [0, "大洋洲"],
          color: {
            blcolor: "#BBFFEF",
            brcolor: "#44A07E",
            color: "#44D7B6",
          },
        },
      ],
      typeTagArgs: {
        skip: 0,
        type: "CITY",
        title: "城市",
        order: "+createTime",
      },
    };
  },
  components: {
    ColorCard,
    BreadCrumb,
    Tag,
    SearchTable,
  },
  computed: {
    breadcrumb() {
      return [
        { name: "地图管理", link: "" },
        { name: "地图列表", link: "" },
      ];
    },
  },
  mounted(){
    this.getCityNums()
  },
  methods: {
    getCityNums() {
      this.$global.GraphqlQuery(this, getCityNums).then((res) => {
        this.$set(this.cardsInfo[0].message,0,res.data[0].numAsia)
        this.$set(this.cardsInfo[1].message,0,res.data[0].numEurope)
        this.$set(this.cardsInfo[2].message,0,res.data[0].numNorthAmerica + res.data[0].numSouthAmerica)
        this.$set(this.cardsInfo[3].message,0,res.data[0].numAfrica)
        this.$set(this.cardsInfo[4].message,0,res.data[0].numOceania)
 
      });
    },
    // 刷新搜索框
    refresh(){
      this.$refs.uniTable.neeedReSearch()
    },
  },
};
</script>

<style scoped lang='scss'>
.pc-map-city {
  .pc-cityList-bread {
    display: flex;
    padding-bottom: 20px;
    border-bottom: 1px solid $border-color;
    > h2 {
      font-size: 20px;
      padding: 35px 40px 0 0;
      align-self: flex-end;
    }
  }
  .pc-map-cityList-cards {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
  .pc-cityList-tab{
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/map/cityList.vue